/**
 * @file index.js
 * @author baoleilei
 * @desc ajax数据格式统一
 */

import $selectAxios from '@/utils/select-axios';
import $http from '../utils/ajax';

export default {
    // 组件中的公用属性
    data() {
        return {
            httpGet: location.href.includes('filldata') ? $selectAxios.selectAxiosGet.bind($selectAxios)
                : $http.get.bind($http),
            httpPost: location.href.includes('filldata') ? $selectAxios.selectAxiosPost.bind($selectAxios)
                : $http.post.bind($http),
            isFillData: location.href.includes('filldata')
        };
    },
    methods: {
        ajaxGet(url, parma) {
            return location.href.includes('filldata') ? this.httpGet(url, parma).then(res => res.data)
                : this.httpGet(url, parma);
        },
        ajaxPost(url, parma) {
            return location.href.includes('filldata') ? this.httpPost(url, parma).then(res => res.data)
                : this.httpPost(url, parma);
        }
    }
};

